import "./instrument";
import * as Sentry from "@sentry/react";

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import posthog from 'posthog-js'

const posthogKey = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const posthogHost = import.meta.env.VITE_POSTHOG_HOST as string | undefined;

if (posthogKey && posthogHost) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    // '2026-05-30' defaults: SPA pageviews auto-captured on history changes,
    // plus $pageleave (powers bounce rate / session duration in Web Analytics)
    defaults: '2026-05-30',
    // Anonymous visitors don't create person profiles (cheaper events);
    // profiles are created on posthog.identify() after signup/login
    person_profiles: 'identified_only',
  });
} else if (import.meta.env.DEV) {
  console.warn('VITE_POSTHOG_KEY or VITE_POSTHOG_HOST variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once VITE_POSTHOG_KEY and VITE_POSTHOG_HOST are configured');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong</p>} showDialog>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)